import {
  Component,
  ViewChild,
  AfterViewInit,
  inject,
  ChangeDetectionStrategy,
  Inject,
} from "@angular/core";
import { AppService } from "../app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MatSelectChange } from "@angular/material/select";
import { provideNativeDateAdapter } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { CommonModule, DatePipe } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-memories",
  standalone: false,
  templateUrl: "./api-audits.component.html",
  styleUrls: ["./api-audits.component.css"],
  providers: [provideNativeDateAdapter(), DatePipe],
  //  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiAuditsComponent {
  displayedColumns: string[] = [
    "processId",
    "url",
    "createdAt",
    "elapsedTime",
    "action",
  ];
  apiKey: any;
  userKey: any;
  createdDateControl = new FormControl();
  maxDate = new Date(); // today
  minDate = new Date(new Date().setMonth(this.maxDate.getMonth() - 3));
  showErrorMsg: boolean = false;
  showErrorText: any;
  status: any;
  csummery: any;
  workspaceName: any;
  txt: any;
  audits: any = [];
  users: any = [];
  audit: any;
  aid: any;
  previewFile = false;
  parsedRequestBody: any;
  parsedResponseBody: any;
  loading = true;
  removeRoute = true;
  selectedProcessId: string | number | null = null;

  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  constructor(
    public appService: AppService,
    public router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.removeRoute = true;
    this.getAudits();
    this.getprofiles();
    this.getConnectorSummary();
    this.previewFile = false;
  }

  onUserChange(event: MatSelectChange): void {
    this.userKey = event.value;
    // this.getAudits();
  }

selectRow(row: any): void {
  this.selectedProcessId = row.processId;
}

  async getConnectorSummary() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

        if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.status = ws.status;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      } 

      if (this.status === "ACTIVATED") {
        this.showErrorMsg = false;
      } else {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
      }

      let activationPayload: any = {
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "usage/connector-summary",
        this.apiKey,
        signature
      );

      if (response && response.status == "Success") {
        this.csummery = response;
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }
  }

  formatTimeStamp(ts: number): string {
    const timestamp = ts * 1000;
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  async copyMessage(message: string) {
    try {
      await navigator.clipboard.writeText(message);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  async getAudits() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.status = ws.status;
        this.workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
      }
    }  

      this.showErrorMsg = this.status !== "ACTIVATED";
      this.showErrorText = this.showErrorMsg
        ? "The selected workspace is currently inactive. Please activate it to proceed."
        : "";

      const activationPayload: any = {
        workspaceKey: this.apiKey,
        sort: -1,
        limit: 50,
        offset: 1,
        routeType:"UI_SESSION"
      };

      if (this.userKey) {
        activationPayload.userKey = this.userKey;
      }

      if (this.createdDateControl.value) {
        activationPayload.startDate = this.datePipe.transform(
          this.createdDateControl.value,
          "yyyy-MM-dd"
        );
      }

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "admin/list-wps-audit",
        this.apiKey,
        signature
      );
      this.loading = false;
      if (response && response.status === "Success") {
        this.audits = response;
        this.txt = response.message;
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in getAudits:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }
  }

  resetFilter() {
    this.createdDateControl.reset();
    this.userKey = "";
    this.getAudits();
  }

  applyFilter() {
    this.getAudits();
  }

  async getprofiles() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

        if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }  

      if (this.status === "ACTIVATED") {
        this.showErrorMsg = false;
      } else {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
      }

      const activationPayload = {
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/list-profile",
        this.apiKey,
        signature
      );

      if (response && response.status == "Success") {
        this.users = response;
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
      // this.appService.addErrorMessage(
      //   "Failed to activate connector: " + (error.message || "Unknown error")
      // );
    }
  }

  readonly dialog = inject(MatDialog);

  async viewAudit(id: any) {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }  

      const activationPayload: any = {
        auditId: id,
        routeType:"UI_SESSION"
      };

      if (this.userKey) {
        activationPayload.userKey = this.userKey;
      }

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "admin/view-wps-audit",
        this.apiKey,
        signature
      );

      if (response && response.status === "Success") {
        this.audit = response.data.audit;
        this.txt = response.message;

        this.parsedRequestBody = JSON.parse(this.audit.requestBody);
        this.parsedResponseBody = JSON.parse(this.audit.responseBody);

        if (id === this.audit.processId) {
          this.removeRoute = false;
        }
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in getAudits:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }
  }

  showPreview(id: string) {
    this.previewFile = true;
    this.viewAudit(id);
  }

  closeRtNav() {
    this.previewFile = false;
    this.selectedProcessId = "";
  }
}
